module.exports = __webpack_public_path__ + "img/logo.1257b8ce.png";